import { SIGN_OUT } from 'Global/Stores/auth'

const DEBUG_UPDATE_LOG_GET = 'API|DEBUG/UPDATE_LOG/GET'
export const DEBUG_UPDATE_LOG_GET_FULFILLED = `FULFILLED_${DEBUG_UPDATE_LOG_GET}`
const DEBUG_UPDATE_LOG_GET_PENDING = `PENDING_${DEBUG_UPDATE_LOG_GET}`
const DEBUG_UPDATE_LOG_GET_REJECTED = `REJECTED_${DEBUG_UPDATE_LOG_GET}`

export const getUpdateLog = () => ({
  meta: { url: '/api/v1/update/dump' },
  type: DEBUG_UPDATE_LOG_GET,
})

const initialState = {
  updateLog: {
    data: [],
    hasError: false,
    isDone: false,
    isPending: false,
  },
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case DEBUG_UPDATE_LOG_GET_FULFILLED:
      return {
        ...state,
        updateLog: {
          ...state.updateLog,
          data: payload.data,
          hasError: false,
          isDone: true,
          isPending: false,
        },
      }

    case DEBUG_UPDATE_LOG_GET_PENDING:
      return {
        ...state,
        updateLog: {
          ...state.updateLog,
          hasError: false,
          isDone: false,
          isPending: true,
        },
      }

    case DEBUG_UPDATE_LOG_GET_REJECTED:
      return {
        ...state,
        updateLog: {
          ...state.updateLog,
          hasError: true,
          isDone: true,
          isPending: false,
        },
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
